

// TikTok Pixel Code Start
!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


  ttq.load('D1VO3PBC77U6OAPOR8T0');
  ttq.page();
}(window, document, 'ttq');



// Smartlook
  window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '34d5f0a59d4b0bd53162068271b5eeaa710ec92e', { region: 'eu' });



//Vacation mode
/*
document.addEventListener('DOMContentLoaded', function () {
  const style = document.createElement('style');
  style.textContent = `
    #checkout.cart__checkout-button {
      opacity: 0.65 !important;
      cursor: not-allowed !important;
    }
  `;
  document.head.appendChild(style);

  const checkoutBtn = document.querySelector('#checkout.cart__checkout-button[name="checkout"]');
  const cartForm = document.querySelector('#cart-form');

  function showVacationPopup(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    alert("We're currently processing existing orders and temporarily not accepting new ones. Thank you for your understanding.");
    return false;
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', showVacationPopup, true);
  }

  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      const activeEl = document.activeElement;
      if (activeEl && activeEl.id === 'checkout') {
        showVacationPopup(e);
      }
    }, true);
  }
});
*/

